import React, { useCallback } from 'react';
import { PaymentSource } from '../../../constants';
import { reportError } from '../../../lib/reportError';
import { useErrorModal } from '../../../hooks/useErrorModal';
import {
  useCart,
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName
} from '../../../hooks/useCart';
import { useChangePaymentSource } from '../../CheckoutPaymentSources';
import { CheckoutSection } from '../../CheckoutSection';
import { PayPalShippingAndPayment } from '../PayPalShippingAndPayment';

export const CheckoutPayPalShippingAndPayment: React.FC = () => {
  const { showErrorModal } = useErrorModal();
  const {
    cart: {
      attributes: { addressId, paypalClientToken }
    }
  } = useCart();
  const [updateCart] = useUpdateCartMutation();
  const changePaymentSource = useChangePaymentSource();

  const onSwitchToAdyen = useCallback(async () => {
    try {
      await updateCart(CartUpdateAction.PaymentSource, {
        [CartUpdatePropertyName.PaymentSource]: PaymentSource.Adyen
      });
    } catch (error) {
      reportError(error);
      showErrorModal();
    }
  }, [showErrorModal, updateCart]);

  const onSubmit = useCallback(() => changePaymentSource(PaymentSource.PayPal), [
    changePaymentSource
  ]);

  return (
    <CheckoutSection title="Shipping &amp; Payment">
      <PayPalShippingAndPayment
        paypalClientToken={paypalClientToken}
        addressId={addressId}
        onSwitchToAdyen={onSwitchToAdyen}
        onSubmit={onSubmit}
      />
    </CheckoutSection>
  );
};
